import $ from 'jquery';

$(document).ready(() => {
  const $mobMenuBtn = $('.js-mobile-menu-btn');
  const $mobNav = $('.js-nav');
  const ACTIVE = 'active';
  const $body = $('body');
  const NOSCROLL = 'no-scroll';

  $mobMenuBtn.on('click', (event) => {
    const $this = $(event.currentTarget);
    $this.toggleClass(ACTIVE);
    $this.closest('.header').toggleClass(ACTIVE);
    $mobNav.toggleClass(ACTIVE);
    $body.toggleClass(NOSCROLL);
  });
});
